import * as TypeGraphQL from "type-graphql";
export var WaitlistEntryScalarFieldEnum;
(function (WaitlistEntryScalarFieldEnum) {
    WaitlistEntryScalarFieldEnum["id"] = "id";
    WaitlistEntryScalarFieldEnum["email"] = "email";
    WaitlistEntryScalarFieldEnum["fullName"] = "fullName";
    WaitlistEntryScalarFieldEnum["companyName"] = "companyName";
    WaitlistEntryScalarFieldEnum["companyWebsite"] = "companyWebsite";
    WaitlistEntryScalarFieldEnum["jobRole"] = "jobRole";
    WaitlistEntryScalarFieldEnum["professionalInvestorConfirmed"] = "professionalInvestorConfirmed";
    WaitlistEntryScalarFieldEnum["status"] = "status";
    WaitlistEntryScalarFieldEnum["queuePosition"] = "queuePosition";
    WaitlistEntryScalarFieldEnum["createdAt"] = "createdAt";
    WaitlistEntryScalarFieldEnum["updatedAt"] = "updatedAt";
    WaitlistEntryScalarFieldEnum["reviewedAt"] = "reviewedAt";
    WaitlistEntryScalarFieldEnum["reviewedById"] = "reviewedById";
})(WaitlistEntryScalarFieldEnum || (WaitlistEntryScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(WaitlistEntryScalarFieldEnum, {
    name: "WaitlistEntryScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=WaitlistEntryScalarFieldEnum.js.map